import { ReactNode } from 'react';
import { Shortcut } from './Item.styled';

type ActionProps = { action: string; Key: ReactNode; prefix?: string };

export const Action = ({ action, Key, prefix }: ActionProps) => {
  return (
    <Shortcut>
      {prefix && <span>{prefix}</span>}
      {Key}
      <span>to {action}</span>
    </Shortcut>
  );
};
